module.exports = __webpack_public_path__ + "img/breach.d3e2c872.png";